import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { breakpoints } from 'styles/utils';
import { useBreakpoint } from 'utils/responsive';

export const useCompareMode = () => {
  const router = useRouter();
  const isMobileScreen = useBreakpoint(breakpoints.down('mdpi'));
  const isCompareMode = router.query.isCompareMode === 'true';

  useEffect(() => {
    if (isCompareMode && isMobileScreen) {
      router.push({ query: { ...router.query, isCompareMode: 'false' } }, undefined, { shallow: true });
    }
  }, [isCompareMode, isMobileScreen, router]);

  const onCompareModeToggle = () => {
    const newCompareMode = !isCompareMode;

    if (newCompareMode) {
      // Turning compare mode ON - keep all query params
      router.push({ query: { ...router.query, isCompareMode: 'true' } }, undefined, { shallow: true });
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { model2, model2_user_id, model2_app_id, ...remainingQuery } = router.query;
      router.push({ query: { ...remainingQuery, isCompareMode: 'false' } }, undefined, { shallow: true });
    }
  };

  return { isCompareMode, onCompareModeToggle };
};
